import React, { useState, useEffect} from "react";
import { Toolbar, Grid, Button, Card, CardContent,TableBody,
    TableRow,  Table, makeStyles, TableHead, TextField,Tooltip
} from "@material-ui/core";
import {DatePicker} from "@material-ui/pickers";
import Pagination from "@material-ui/lab/Pagination";
import { GlobalHeader } from "components/navigation/components/GlobalHeader";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import CustomInput from "components/custom/CustomInput";
import Colors from "shared/color";
import { autoDisbursementListing, autoDisbursementDropDown,ExportToExcelAutodisburse} from "shared/api/purple/autoDisbursement";
import Header from "components/navigation/Header";
import SettlementDetailsModel from "./dialog/settlementdetails";
import DisburseModel from "./dialog/disburse";
import BankDetailsModel from "./dialog/bankdetails";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import VisibilityIcon from "@material-ui/icons/Visibility";
import KisshtLink from 'components/ui/KisshtLink';
import './auto.css'
import { ROUTES_VAR, ROUTE_NAME, PERMISSIONS } from "shared/constants";
import CustomSelect from "components/custom/CustomSelect";
import {toastSuccess, toastError,readableFormatDate, DateHandle,filterValidation } from "shared/utils";
import KisshtButton from "components/ui/KisshtButton";
import moment from "moment";
import {getExportToExcelList } from "shared/api";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

const style = makeStyles((theme) => ({
    
    table: {
      "& tbody:nth-child(even)": {
        backgroundColor: Colors["lighterPurple"],
        // borderWidth:'2px'
      },
    },
    bullet: {
      display: "inline-block",
      margin: "0 2px",
      transform: "scale(0.8)",
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
    scrollingwrapper: {
      overflowX: "scroll",
      overflowY: "hidden",
      whiteSpace: "nowrap",
      "& .MuiGrid-container": {
        flexWrap: "nowrap",
      },
      "& .MuiGrid-root.card.MuiGrid-item": {
        display: "inline-block",
      },
      "& .::-webkit-scrollbar": {
        display: "scrollbar",
      },
    },
    card: {
      "& .MuiCardHeader-root": {
        padding: "8px",
        paddingBottom: "0px",
      },
    },
  }));
  const iconStyle={
      background:"rgb(198 185 221)",
      opacity:"1",
      padding:"4px",
      borderRadius:"50%",
      height:"30px",
      width:"30px",
      verticalAlign:"middle",
      margin:"0px",
      float:'left'
  }
export const AutoDisbursement = (props) => {
    const classes = style();
    
    const { params, updateQueryParams, delteQueryParams } = props;
    const [search] = useState(params["search"] || "");
    
    const [openSettlemetDetailsModal,setSettlementDetailsModal] = useState(false);
    const [openBankDetailsModal,setBankDetailsModal] = useState(false);
    const [openDisburseModal,setDisburseModal] = useState(false);
    const [disbursementStatus, setDisbursementStatus]  = useState();
    const [settlementStatus, setSettlementStatus] = useState();
    const [selectParameters, setSelectParameters] = useState();
    const [selectData, setSelectData] = useState("");
    const [disbursementData, setDisbursementData]  = useState("");
    const [settlementData, setSettlementData] = useState(params["settlementData"] || "");
    const [searchData, setSearchData] = useState(params["searchData"] || "");
    const [fromDate, setFormDate] = useState(params["fromDate"] || null);
    const [toDate, setToDate] = useState(params["toDate"] || null);
    const [settlementModalData , setSettlementModalData] = useState()
    const [disburseModalData , setdisburseModalData] = useState()
    const [bankDetailsModalData, setBankDetailsModalData] = useState()
    
    const [currentPage, setCurrentPage] = useState(1)
    const [autoDisbursementListData,setAutoDisbursementListData] =useState("")
    const [AutoDisbursementPageCount,setAutoDisbursementPageCount] =useState(0)
    const [count, setCount] = useState();
    const [reload, setreload] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    let text =JSON.stringify(new Date())
    const myArray = text.split(" ");
    const dateFormat = myArray[0].split("T")
   let newdata= dateFormat[0].replace(/["]/g ,"")

    useEffect(() => {
      fetchAutoDisDropDown();
      fetchAutoDisbursementListApi(0)
      // eslint-disable-next-line
      }, [reload]);

const fetchAutoDisbursementListApi = async (page) => {
  const listingData = {
    "offset": page,
    "limit": 20,
    [selectData]: searchData,
    "from_date": fromDate,
    "to_date": toDate,
    "disbursement_status": disbursementData,
    "is_settled": settlementData
  }
  Object.keys(listingData).forEach(key => {
    if (listingData[key] === '' || listingData[key] === null) {
      delete listingData[key];
    }
  });
  
  await updateQueryParams({ search });
  autoDisbursementListing(listingData)
    .then((res) => {
      
      if (res?.data?.list?.length > 0) {
        setAutoDisbursementListData(res?.data?.list);
        setCount(res?.data?.count);
        var quotient = Math.ceil(res?.data?.count/20)
        setAutoDisbursementPageCount(quotient);
      } else {
        setAutoDisbursementListData([]);
      }
    })
    .catch((error) => {
      setAutoDisbursementListData([]);
    
    });
};
    const fetchAutoDisDropDown = async () =>{
      
      autoDisbursementDropDown()
      .then((res) =>{
        if(res.data){
          let dropDownData = res.data.autoDisbursementSearchOption
          setDisbursementStatus(dropDownData.disbursement_status);
          setSettlementStatus(dropDownData.is_settled);
          setSelectParameters(dropDownData.search_parameters)
          
        }
      })
      .catch((error) =>{
        
        return null;
      })
    }
    let newArr = {...disbursementStatus};
    Object.keys(newArr).forEach(key => {
      if (newArr[key] === '') {
        delete newArr[key];
      }
    });
    

    const autoDisburseExportHandle = async()=>{
      const payload = {
          "module_name": "auto_disbursement",
          "checkbox_ids": "",
          [selectData]: searchData,
          "from_date": fromDate,
          "to_date": toDate,
          "disbursement_status": disbursementData,
          "is_settled": settlementData
      }
      Object.keys(payload).forEach(key => {
        if (payload[key] === '' || payload[key] === null) {
          delete payload[key];
        }
      });
      getExportToExcelList(payload)
      .then((res) => {
        if (res.hasOwnProperty("success") && res.success) {
          if(res){
            toastSuccess(res.message);
          }
          else{
            toastError(res.message);
          }
        }
      })
      .catch((error) => {
        toastError(error.message);
      });
    }
    const showSettlementModel = async (settlement_id) => {
       setSettlementModalData(settlement_id)
        await setSettlementDetailsModal(true);        
      };
      
    const showBankModel = async (data) => {
      setBankDetailsModalData(data)
        await setBankDetailsModal(true);        
      };
    const showDisburseModel = async (data) => {
      setdisburseModalData(data)
        await setDisburseModal(true);        
      };
    
      const handleSettleModalClosed = (sts) => {
        if (sts) {
            setSettlementDetailsModal(false);
        } else {
            setSettlementDetailsModal(sts);
        }
      };
      const handleBankModalClosed = (sts) => {
        if (sts) {
          setBankDetailsModal(false);
        } else {
          setBankDetailsModal(sts);
        }
      };
      const handleDisburseModalClosed = (sts) => {
        if (sts) {
          setDisburseModal(false);
        } else {
          setDisburseModal(sts);
        }
      };

      const handleSelect =  async (e) =>{
        e.persist();
        let item = e.target.value;
        if(!item){
           setSelectData("");
           setSearchData("");
           setCurrentPage(1)
           setreload(!reload);
        }
        else{
          setSelectData(item)
          setSearchData("")
        }
      }
      
      const OnHandleSearch = (e) => {    
        const validation_msg = filterValidation(selectData,e.target.value)
        setSearchData(e.target.value)
        setErrorMessage(validation_msg)
      }


      const handleDisbursement = async (e) =>{
        let item = e.target.value;
        if(!item){
          await setDisbursementData("")
        }
        else{
          setDisbursementData(item)
        }
      }

      const handleSettlementData =  async (e) =>{
        let item = e.target.value;
        if(!item){
          await setSettlementData("")
        }
        else{
          setSettlementData(item)
        }
      }


      const onPageChange = (event, value) => {
        setCurrentPage(value); 
        fetchAutoDisbursementListApi(value-1) 
      }


      const refreshHandler = async (_) => {
        setSelectData("")
        setSearchData(params["searchData"] || "")
        setDisbursementData("")
        setSettlementData(params["settlementData"] || "")
        setFormDate(params["fromDate"] || null)
        setToDate(params["toDate"] || null)
        setCurrentPage(1)       
        await delteQueryParams();
        setreload(!reload);
      };

      const searchAutoDisbursal = () => {
        fetchAutoDisbursementListApi(0)
        setCurrentPage(1) 
      }

    const formDateHandle =(e) =>{
      const formated_date =  DateHandle(e);
      setFormDate(formated_date)
    }
    const toDateHandle =(e) =>{
      const formated_date =  DateHandle(e);
      setToDate(formated_date)
    }


   return (
      <>
        <Header open={props.open}>
          <Toolbar
            style={{
              backgroundColor: Colors["AppBarBGPurple"],
              minHeight: "65px",
            }}
          >
            <GlobalHeader closeSideDrawer={() => {}} />
          </Toolbar>
          <Toolbar>
          <Grid container spacing={1} className="crum_padding">
            <Grid item lg={3} md={3} sm={4} xs={9}>
              <BreadcrumbsHeader text="Auto Disbursement Panel" />
            </Grid>
            <Grid item lg={9} md={9} sm={12} xs={12} className='top_spacing_btn'>
              <Grid container spacing={1} justifyContent="flex-end">
                <Grid item >
                  <Tooltip title="Export to Excel">
                    <KisshtButton
                      size="small"
                      endIcon={<CloudUploadIcon />}
                      route={ROUTE_NAME.auto_disbursement}
                      permission={PERMISSIONS.auto_disbursement.export_excel}
                      onClick={() => autoDisburseExportHandle()}
                      className="common_kissht_btn"
                      disabled={(fromDate != null && toDate === null) || (fromDate === null && toDate != null)  || (selectData && searchData ==="") ? true : false}
                      >Export To Excel
                    </KisshtButton>
                  </Tooltip>
                </Grid>
              </Grid>
              </Grid> 
          
          <Grid item xs={12} className="crum_innerPadding">
            <Grid container spacing={1} alignItems="center">
                  <Grid item >
                    <CustomSelect
                      nulloption="Select"
                      // style={{width:'275px'}}
                      options={selectParameters}
                      onChange={handleSelect}
                      value={selectData}
                      className="common_global_filter"
                    />
                  </Grid>
                  <Grid item>
                    <Grid>
                      <CustomInput
                        // style={{width:'200px'}}
                        placeholder="Search"
                        onChange={(e) => OnHandleSearch(e)}
                        value={searchData}
                        className="common_custom_input"
                      />
                    </Grid>
                    <Grid>
                        {searchData ? <span style={{"color":"red",fontSize:'13px',position:'absolute'}}>{errorMessage}</span>: ""}
                    </Grid>
                  </Grid>
                  <Grid item >
                    <CustomSelect
                      // style={{width:'200px'}}
                      nulloption="Disbursement  Status"
                      options={newArr}
                      onChange={handleDisbursement}
                      value={disbursementData}
                      className="common_global_filter"
                    />
                  </Grid>
                  <Grid item >
                    <CustomSelect
                      // style={{width:'220px'}}
                      nulloption="Select Settlement Status"
                      options={settlementStatus}
                      onChange={handleSettlementData}
                      value={settlementData}
                      className="common_global_filter"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item style={{marginBottom:'1px'}}>
                        <label className="from-to-date-label">From Date</label>
                          <DatePicker 
                              helperText={false}
                              className="date_style"
                              disableFuture
                              format="yyyy-MM-dd"
                              onChange={(e) =>formDateHandle(e)}
                              value={fromDate}
                              placeholder={"Select From Date"}
                              renderInput={fromDateProps => <TextField {...fromDateProps} style={{color:'#e2e8f0'}}/>}
                            />
                          <label className="from-to-date-label">To Date</label>
                          <DatePicker 
                              disableFuture
                              className="date_style"
                              format="yyyy-MM-dd"
                              helperText={false}
                              onChange={(e) => fromDate === "" ? alert("first pick from date"): toDateHandle(e)  }
                              value={toDate}
                              placeholder={"Select To Date"}
                              renderInput={toDateProps => <TextField {...toDateProps} style={{color:'#e2e8f0'}}/>}
                            />
                        </Grid>
                      <Grid item>
                        <Button
                          disabled={(searchData?.length > 0  || disbursementData?.length > 0 || settlementData?.length > 0 || (fromDate && toDate)) && !errorMessage ? false : true}                          size="small"
                          variant="contained"
                          className="shadow-none"
                          color="primary"
                          onClick={() => searchAutoDisbursal()}
                          style={{marginTop:'2px',marginLeft:'10px'}}
                        >
                          Search
                        </Button>
                      </Grid>
                      <Grid item>
                      <Button style={{marginLeft:'6px'}}
                          size="small" color="primary"
                          onClick={refreshHandler} 
                            >Reset
                      </Button>
                    </Grid>
                </Grid>  
              </Grid>    
            </Grid>
          </Grid>
          
         </Grid> 
          </Toolbar>  
        </Header>
  
        <div className="padding_top_auto_outbond">

        {autoDisbursementListData.length > 0 ?
          <Card
            style={{
              boxShadow: `0px 3px 6px ${Colors["LightPurpleShadow"]}`,
            }}
          >
            <CardContent style={{ height: "50px" }}>
              <Grid container className="grid-vertical-align-center">
                <Grid item xs={12}>
                  <p
                    className="text-xs"
                    style={{
                      color: Colors["lightPurple"],
                      float: "right"
                    }}
                  >
                  {
                    count < 10 ? 
                    null:
                    <Pagination color="primary" count={AutoDisbursementPageCount} page={currentPage} onChange={onPageChange} />
                  }
                  </p>
                </Grid>
              </Grid>
            </CardContent>
            <CardContent style={{overflowX:'scroll'}} className="_commontable_mobile">

            <Table className={classes.table}>
                          <TableHead>
                            <TableRow>                
                            <TableBodyCell className=" new_style " >
                            Rufilo Transaction Id	
                            </TableBodyCell>
                            <TableBodyCell className=" new_style ">
                            Settlement Id		
                            </TableBodyCell>
                            <TableBodyCell className=" new_style ">
                            Beneficialry Type	
                            </TableBodyCell>
                            <TableBodyCell className=" new_style ">
                            Beneficiary Details	
                            </TableBodyCell>
                           <TableBodyCell className=" new_style ">
                           Settlement Amount	
                            </TableBodyCell>
                            <TableBodyCell className=" new_style ">
                           Settlement Status	
                            </TableBodyCell>
                            <TableBodyCell className=" new_style ">
                            Disbursement Ref No	
                            </TableBodyCell>
                            <TableBodyCell className=" new_style ">
                            Disbursement Status	
                            </TableBodyCell>
                            </TableRow>
                          </TableHead>
                          {autoDisbursementListData?.map((item) =>{
                            let BankDetails = {
                              "bank_account_holder_name":item.bank_account_holder_name,
                              "bank_account_no": item.bank_account_no,
                              "bank_name":item.bank_name,
                              "bank_branch":item.bank_branch,
                              "bank_ifsc_code":item.bank_ifsc_code
                            }
                          return <TableBody >
                                <TableRow>
                                <TableBodyCell style={{color:"#355e3b",fontWeight:"400"}} className="new_style">
                                <KisshtLink
                                  to={`/transactions/${item.transaction_reference_number}`}
                                  permission={PERMISSIONS.auto_disbursement.transaction_view}
                                  route={ROUTE_NAME.auto_disbursement}
                                  >{
                                    item.disbursement_status === "SUCCESS" ? 
                                    <span   style={{ color: "green"}}>  {item.transaction_reference_number}</span>
                                    :
                                    <span   style={{ color: "blue"}}>  {item.transaction_reference_number}</span>
                                  }
                                </KisshtLink>
                                </TableBodyCell>
                                <TableBodyCell className="new_style">
                                {item.settlement_id} 
                                </TableBodyCell>
                                <TableBodyCell className="new_style">
                                {item.beneficiary_type}
                                </TableBodyCell>
                                {item.beneficiary_fname != null || item.beneficiary_mobile_number != null || item.beneficiary_email != null ?
                                <TableBodyCell className="new_style"> 
                                <KisshtLink
                                  // to={`/transactions/${item.rufilo_transaction_id}`} 
                                  to={`${ROUTES_VAR.users}/${item.user_reference_number}`}
                                  permission={PERMISSIONS.auto_disbursement.user_view}
                                  route={ROUTE_NAME.auto_disbursement}
                                  >
                                  {item.beneficiary_fname} {item.beneficiary_lname}  
                                </KisshtLink> / {item.beneficiary_mobile_number} /
                                <Tooltip arrow title={item.beneficiary_email} placement="top">
                                      <AlternateEmailIcon style={{color:"blue",fontSize:"20px"}}/>
                                 </Tooltip>
                                </TableBodyCell>
                                 : "--"
                                }
                                <TableBodyCell className="new_style">
                                {item.settlement_amount}
                                </TableBodyCell>
                                <TableBodyCell className="new_style">
                                <BootstrapBadge
                                    color="#fff"
                                    text={item.is_settled}
                                ></BootstrapBadge>
                                </TableBodyCell>
                                <TableBodyCell className="new_style">
                                {item.disbursement_reference_number}
                                </TableBodyCell>
                                <TableBodyCell className="new_style">
                                <BootstrapBadge
                                   color="#fff"
                                  text={item.disbursement_status}
                                ></BootstrapBadge>
                                </TableBodyCell>
                                <TableRow style={{height: "1px", boxShadow: "initial"}}></TableRow>

                                </TableRow>
                                    <TableRow className="new_style new_style_css">
                                      <TableBodyCell  style={{paddingRight:"2Opx",fontSize:'12px',}} className="new_style ">
                                        <div className="date_column_style">
                                          <Tooltip arrow title="Settlement Date" placement="bottom">
                                          <DateRangeOutlinedIcon  style={iconStyle}/>
                                          </Tooltip>
                                          <Grid item className="style_date"> {item.settlement_date == null ? "  --" : item.settlement_date}</Grid>
                                        </div>
                                      </TableBodyCell>

                                      <TableBodyCell colspan="2" style={{paddingRight:"2Opx",fontSize:'12px'}} className="new_style "> 
                                          <div className="date_column_style">
                                            <Tooltip arrow title="Final Approval Date" placement="bottom">
                                            <DateRangeOutlinedIcon style={iconStyle} />
                                            </Tooltip>
                                            <Grid item className="style_date"> {item.created_on}</Grid>
                                          </div>
                                          
                                      </TableBodyCell>
                                      
                                      <TableBodyCell className="new_style ">
                                      <Tooltip arrow title="View Settlement Details">
                                      <KisshtButton
                                          size="small"
                                          startIcon={<VisibilityIcon />}
                                          variant="outlinedPrimary"
                                          onClick={() => showSettlementModel(item.settlement_id)}
                                          route={ROUTE_NAME.auto_disbursement}
                                          permission={PERMISSIONS.auto_disbursement.settlement_details}
                                          className="common_kissht_btn"
                                        >Settlement Details</KisshtButton>
                                        </Tooltip>
                                      </TableBodyCell>

                                      <TableBodyCell colspan="2" className="new_style ">
                                      <Tooltip  arrow title="View Bank Details"  placement="right-start">
                                      <KisshtButton
                                        size="small"
                                        variant="outlinedPrimary"
                                        startIcon={<VisibilityIcon />}
                                        onClick={() => showBankModel(BankDetails)}
                                        route={ROUTE_NAME.auto_disbursement}
                                        permission={PERMISSIONS.auto_disbursement.bank_details}
                                        className="common_kissht_btn"
                                        >Bank Details</KisshtButton> 
                                        </Tooltip>
                                      </TableBodyCell>

                                      <TableBodyCell colspan="2" className="new_style ">
                                      <Tooltip arrow title="View Disbursement Details">
                                      <KisshtButton
                                        size="small"
                                        variant="outlinedPrimary"
                                        disabled={item.disbursement_id != null ? false : "disabled" }
                                        startIcon={<VisibilityIcon />}
                                        onClick={() => showDisburseModel(item)}
                                        route={ROUTE_NAME.auto_disbursement}
                                        permission={PERMISSIONS.auto_disbursement.disbursement_details}
                                        className="common_kissht_btn"
                                        >Disburse
                                      </KisshtButton>

                                      </Tooltip>

                                      </TableBodyCell>
                                    </TableRow>
                                <TableRow style={{height:"15px"}}></TableRow>
                              </TableBody>
                             
                               } )}
                              
            </Table>
            </CardContent>
            <CardContent style={{ height: "50px",paddingBottom:'70px'}}>
              <Grid container className="grid-vertical-align-center">
                <Grid item xs={12}>
                  <p
                    className="text-xs"
                    style={{
                      color: Colors["lightPurple"],
                      float: "right"
                    }}
                  >
                       {
                        count < 10 ? 
                    null:
                    <Pagination color="primary" count={AutoDisbursementPageCount} page={currentPage} onChange={onPageChange} />
                   }
                   </p>
                </Grid>
              </Grid>
            </CardContent>
          </Card> : <div className='global_center'> No records found.</div>}
          {openSettlemetDetailsModal && (
          <SettlementDetailsModel
            visible={openSettlemetDetailsModal}
            callbackEvent={handleSettleModalClosed}
            data={settlementModalData}
          ></SettlementDetailsModel>
        )}
         {openBankDetailsModal && (
          <BankDetailsModel
            visible={openBankDetailsModal}
            callbackEvent={handleBankModalClosed}
            data={bankDetailsModalData}
          ></BankDetailsModel>
        )}
         {openDisburseModal && (
          <DisburseModel
            visible={openDisburseModal}
            callbackEvent={handleDisburseModalClosed}
            data={disburseModalData}
          ></DisburseModel>
        )}
        </div>
      </>
    );
  };
  

export default (AutoDisbursement)